/**
 * A positional shadow's `intensity`, which three's lit programs read as the shadow's opacity: the
 * light's `shadow_opacity` while the shadow holds a slot of the atlas, and none without one. Godot
 * sends an opacity of zero for a light the atlas holds no slot for (`light_storage.cpp:948-952`,
 * `:1027`). The light's component and its distance fade write the opacity through `intensity`.
 */
/**
 * Gives every instance of `shadowClass` the slotted `intensity`. three types `intensity` as a field,
 * so the accessor goes on the prototype. `LightShadow`'s constructor and `copy` assign it, and an
 * assignment reaches an inherited setter.
 */
export function readIntensityThroughSlot(shadowClass) {
    Object.defineProperty(shadowClass.prototype, 'intensity', {
        get() {
            return this.slot === null ? 0 : this.opacity;
        },
        set(opacity) {
            this.opacity = opacity;
        },
        configurable: true,
    });
}
//# sourceMappingURL=slotOpacity.js.map